import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import userPlaceholder from "../../assets/images/placeholder.jpg";

import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import {
	// Controller,
	useFieldArray,
	useForm,
} from "react-hook-form";
// import ReactQuill from "react-quill";
import server from "../../api/server";
import { Col } from "reactstrap";

const LicensIndex = () => {
	const auth = useSelector(state => state.auth.user);
	const [licensSection, setLicensSection] = useState({
		section: {
			sectionTitle: {
				ar: "",
				en: "",
			},
			slug: "licens",
			sectionSubTitle: {
				ar: "",
				en: "",
			},
			licensData: [
				{
					img: "",
					title: { ar: "", en: "" },
					subtitle: { ar: "", en: "" },
				},
			],
		},
	});
	const [activeModalIndex, setActiveModalIndex] = React.useState(null);
	const [isAdding, setIsAdding] = React.useState(false);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);
	const [isUploading, setIsUploading] = useState(false);
	const [picture, setPicture] = useState({
		blob: true,
		path: "",
		placeholder: true,
	});
	const handlePicture = e => {
		const pictureElement = document.querySelector("#picture");
		const mainImage = new FormData();
		mainImage.append("file", pictureElement.files[0]);
		setIsUploading(true);
		axios
			.post(`${process.env.REACT_APP_MAIN_URL}/api/upload`, mainImage, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				setIsUploading(false);
				setPicture({
					...picture,
					path: `${process.env.REACT_APP_MAIN_URL}/${response.data.data.file.path}`,
				});
			})
			.catch(_ => {
				setIsUploading(false);
				toast.error("حدث خطا أثناء رفع الصورة");
				setTimeout(
					__ => toast.warn("الرجاء المحاولة مره اخرة او تغير الصورة"),
					800
				);
			});
	};
	const {
		register,
		control,
		handleSubmit,
		getValues,
		reset,
		setValue,
		formState: { errors },
	} = useForm({
		defaultValues: {
			sectionTitle: {
				ar: "",
				en: "",
			},
			slug: "licens",
			sectionSubTitle: {
				ar: "",
				en: "",
			},
			licensData: [],
		},
	});

	const {
		register: addRegister,
		handleSubmit: handleAddSubmit,
		reset: resetAddForm,
		formState: { errors: addErrors },
	} = useForm({
		defaultValues: {
			img: "",
			title: { ar: "", en: "" },
			subtitle: { ar: "", en: "" },
		},
	});

	const addLicensHandler = data => {
		data.img = picture.path;
		if (data.img === "") {
			toast.error("يرجى رفع صورة");
			return;
		}
		append(data);
		resetAddForm();
		setIsAdding(false); // تقفل المودال
		setPicture({
			blob: true,
			path: userPlaceholder,
			placeholder: true,
		});
	};

	const mainHandleImageUpload = async event => {
		setLoading(true);
		const file = event.target.files[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}
			);

			const uploadedPath = response.data.data.file.path;

			// ✅ Set uploaded image path to icon field
			setValue("image", uploadedPath);
			toast.success("تم رفع الصورة بنجاح!");
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة مره اخرى!");
		} finally {
			setLoading(false);
		}
	};
	const editLicensHandler = (data, index) => {
		const updatedLicens = [...fields]; // أو licensData إن كنت تستخدمها
		updatedLicens[index] = data.licensData[index];
		updatedLicens[index].img = picture.path;

		setValue("licensData", updatedLicens); // أو dispatch Redux أو أي تحديث تريده
		setActiveModalIndex(null);
		setPicture({
			blob: true,
			path: userPlaceholder,
			placeholder: true,
		});
	};

	const { fields, append, remove } = useFieldArray({
		control,
		name: "licensData",
	});

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "جميع الاعتمادات والتراخيص ",
				breadcrumb: " الاعتمادات والتراخيص ",
				button: {
					show: false,
					text: false,
					link: false,
				},
			})
		);
		try {
			const pageData = await server(cookie).get(
				"/pages/licens/sections/licens"
			);
			reset(pageData?.data?.data?.section);
			setLicensSection(pageData?.data?.data?.section);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	useEffect(() => {
		isAdding
			? setPicture({
					blob: true,
					path: userPlaceholder,
					placeholder: true,
			  })
			: setPicture({
					blob: true,
					path: "",
					placeholder: false,
			  });
	}, [isAdding]);

	const onSubmit = async data => {
		setLoading(true);

		try {
			await server(cookie).put(`/pages/licens/sections/licens`, {
				section: data,
			});
			toast.success("تم تعديل البيانات بنجاح");
			reset();
			onStart();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};
	return (
		<section>
			{loading && <Loader />}
			<div className="row">
				<div className="col-xs-12">
					<div className="card">
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className="row mb-3">
								{/* Arabic title Company */}
								<div className="col-xs-12 col-md-6">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="titleAr">العنوان بالعربية</label>
											<input
												type="text"
												id="titleAr"
												{...register("sectionTitle.ar", {
													required: "هذا الحقل مطلوب",
												})}
											/>
											{errors?.sectionTitle?.ar && (
												<p className="text-danger mt-1">
													{errors.sectionTitle.ar.message}
												</p>
											)}
										</div>
									</div>
								</div>

								{/* English title Company */}
								<div className="col-xs-12 col-md-6">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionEn">العنوان بالانجليزية</label>
											<input
												type="text"
												id="titleen"
												{...register("sectionTitle.en", {
													required: "هذا الحقل مطلوب",
												})}
											/>
											{errors?.sectionTitle?.en && (
												<p className="text-danger mt-1">
													{errors.sectionTitle.en.message}
												</p>
											)}
										</div>
									</div>
								</div>
								{/* Arabic subTitle  */}
								<div className="col-xs-12 col-md-6">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="titleAr">العنوان الفرعى بالعربية</label>
											<textarea
												type="text"
												id="sectionSubTitleAr"
												{...register("sectionSubTitle.ar", {
													required: "هذا الحقل مطلوب",
												})}
											/>
											{errors?.sectionSubTitle?.ar && (
												<p className="text-danger mt-1">
													{errors.sectionSubTitle.ar.message}
												</p>
											)}
										</div>
									</div>
								</div>

								{/* English subTitle  */}
								<div className="col-xs-12 col-md-6">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionEn">
												العنوان الفرعى بالانجليزية
											</label>
											<textarea
												type="text"
												id="titleen"
												{...register("sectionSubTitle.en", {
													required: "هذا الحقل مطلوب",
												})}
											/>
											{errors?.sectionSubTitle?.en && (
												<p className="text-danger mt-1">
													{errors.sectionSubTitle.en.message}
												</p>
											)}
										</div>
									</div>
								</div>
							</div>
							{/*Licens */}
							<div>
								<div className="d-flex align-items-center justify-content-between px-4 my-5">
									<h3 className="main-title ps-3">
										{" "}
										جميع الاعتمادات والتراخيص{" "}
									</h3>
									<button
										type="button"
										onClick={() => {
											setIsAdding(true);
										}}
										className="bg-green-500 text-white px-3 py-2 rounded btn btn-success"
									>
										+ اضافة ترخيص جديد
									</button>
								</div>

								<div className="rounded  mx-3">
									<table className="table ">
										<thead>
											<tr>
												<th>العناون (عربي)</th>
												<th>الوصف (عربي)</th>
												<th>إجراءات</th>
											</tr>
										</thead>
										<tbody>
											{fields.map((field, index) => (
												<tr key={field.id}>
													<td>{getValues(`licensData.${index}.title.ar`)}</td>
													<td
														style={{
															whiteSpace: "nowrap",
															maxWidth: "200px",
															overflow: "hidden",
															textOverflow: "ellipsis",
														}}
													>
														{getValues(`licensData.${index}.subtitle.ar`)}
													</td>
													<td>
														<button
															className="bt bt-sm bt-success"
															onClick={e => {
																e.preventDefault();
																setActiveModalIndex(index);
															}}
														>
															<i className="fas fa-edit"></i>
														</button>

														<button
															type="button"
															className="bt bt-sm bt-danger"
															style={{ marginInlineStart: "5px" }}
															onClick={() => remove(index)}
														>
															<i className="fas fa-trash"></i>
														</button>
													</td>
												</tr>
											))}
											{fields.length === 0 && (
												<tr>
													<td colSpan="3" className="text-center">
														لا يوجد بيانات
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</div>
							<Col xs={12} md={6} className="mx-auto">
								<div className="form-item mt-3">
									<button className="bt bt-success btn-block">ارسال</button>
								</div>
							</Col>
						</form>
						{/* Edit modal */}
						{fields.map((field, index) => {
							if (activeModalIndex === index) {
								return (
									<div
										key={`modal-${field.id}`}
										className="modal fade show"
										style={{
											zIndex: 100000000,
											background: "rgba(20, 20, 20, 0.71)",
											position: "fixed",
											width: "85%",
											height: "100vh",
											top: "0px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											left: "0px",
											padding: "15rem 3rem 8rem",
										}}
									>
										<div className="modal-dialog modal-lg">
											<form
												onSubmit={handleSubmit(data =>
													editLicensHandler(data, index)
												)}
											>
												<div className="modal-content">
													<div className="modal-header">
														<h5 className="modal-title">
															تعديل بيانات الترخيص
														</h5>
														<button
															type="button"
															className="btn-close m-0"
															onClick={() => {
																setActiveModalIndex(null);
															}}
															aria-label="Close"
														></button>
													</div>

													<div className="form-item m-3">
														<label htmlFor="picture">صورة </label>
														<input
															type="file"
															onChange={handlePicture}
															id="picture"
														/>
														{isUploading ? (
															<p style={{ marginTop: "1rem" }}>
																...جارى رفع الصورة
															</p>
														) : (
															<img
																src={
																	picture && picture.path
																		? picture.path
																		: `${getValues(`licensData.${index}.img`)}`
																}
																alt="avatar"
																className="imagePreview-2"
															/>
														)}
													</div>

													<div className="modal-body">
														<div className="mb-3">
															<label className="form-label">
																العنوان باللغة العربية
															</label>
															<input
																{...register(`licensData.${index}.title.ar`, {
																	required: "هذا الحقل مطلوب",
																})}
																className="form-control"
																dir="rtl"
															/>
															{errors?.licensData?.[index]?.title?.ar && (
																<p className="text-danger mt-1">
																	{errors.licensData[index].title.ar.message}
																</p>
															)}
														</div>

														<div className="mb-3">
															<label className="form-label">
																العنوان باللغة الإنجليزية
															</label>
															<input
																{...register(`licensData.${index}.title.en`, {
																	required: "هذا الحقل مطلوب",
																})}
																className="form-control"
															/>
															{errors?.licensData?.[index]?.title?.en && (
																<p className="text-danger mt-1">
																	{errors.licensData[index].title.en.message}
																</p>
															)}
														</div>

														<div className="mb-3">
															<label className="form-label">
																الوصف باللغة العربية
															</label>
															<textarea
																{...register(`licensData.${index}.subtitle.ar`)}
																className="form-control"
																dir="rtl"
																style={{ resize: "none", height: "120px" }}
															/>
															{errors?.licensData?.[index]?.subtitle?.ar && (
																<p className="text-danger mt-1">
																	{errors.licensData[index].subtitle.ar.message}
																</p>
															)}
														</div>

														<div className="mb-3">
															<label className="form-label">
																الوصف باللغة الإنجليزية
															</label>
															<textarea
																{...register(`licensData.${index}.subtitle.en`)}
																className="form-control"
																style={{ resize: "none", height: "120px" }}
															/>
															{errors?.licensData?.[index]?.subtitle?.en && (
																<p className="text-danger mt-1">
																	{errors.licensData[index].subtitle.en.message}
																</p>
															)}
														</div>
													</div>

													<div className="modal-footer">
														<button type="submit" className="btn btn-secondary">
															تعديل
														</button>
													</div>
												</div>
											</form>
										</div>
									</div>
								);
							}
							return null;
						})}

						{/* add modal */}
						{isAdding && (
							<div
								className="modal fade show"
								style={{
									zIndex: 100000000,
									background: "rgba(20, 20, 20, 0.71)",
									position: "fixed",
									width: "85%",
									height: "100vh",
									top: "0px",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									left: "0px",
									padding: "15rem 3rem 8rem",
								}}
							>
								<div
									className="modal-dialog modal-lg"
									onClick={e => e.stopPropagation()}
								>
									<form onSubmit={handleAddSubmit(addLicensHandler)}>
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title">اضافة ترخيص جديد</h5>
												<button
													type="button"
													className="btn-close m-0"
													onClick={() => {
														setIsAdding(false);
														setPicture({
															blob: true,
															path: userPlaceholder,
															placeholder: true,
														});
													}}
													aria-label="Close"
												></button>
											</div>
											<div className="modal-body">
												<div className="form-item">
													<label htmlFor="picture">صورة </label>
													<input
														type="file"
														onChange={handlePicture}
														id="picture"
													/>
													{isUploading ? (
														<p style={{ marginTop: "1rem" }}>
															{" "}
															...جارى رفع الصورة
														</p>
													) : (
														<img
															src={
																picture && picture.blob
																	? picture.path
																	: `${process.env.REACT_APP_MAIN_URL}/${picture.path}`
															}
															alt="avatar"
															className="imagePreview-2"
														/>
													)}
												</div>
												<div className="mb-3">
													<label className="form-label">
														الاسم باللغة العربية
													</label>
													<input
														{...addRegister("title.ar", {
															required: "هذا الحقل مطلوب",
														})}
														className="form-control"
														dir="rtl"
													/>
													{addErrors?.title?.ar && (
														<p className="text-danger mt-1">
															{addErrors.title.ar.message}
														</p>
													)}
												</div>

												<div className="mb-3">
													<label className="form-label">
														الاسم باللغة الإنجليزية
													</label>
													<input
														{...addRegister("title.en", {
															required: "هذا الحقل مطلوب",
														})}
														className="form-control"
													/>
													{addErrors?.title?.en && (
														<p className="text-danger mt-1">
															{addErrors.title.en.message}
														</p>
													)}
												</div>

												<div className="mb-3">
													<label className="form-label">
														الوصف باللغة العربية
													</label>
													<textarea
														{...addRegister("subtitle.ar")}
														className="form-control"
														dir="rtl"
														style={{ resize: "none", height: "120px" }}
													/>
													{addErrors?.subtitle?.ar && (
														<p className="text-danger mt-1">
															{addErrors.subtitle.ar.message}
														</p>
													)}
												</div>

												<div className="mb-3">
													<label className="form-label">
														الوصف باللغة الإنجليزية
													</label>
													<textarea
														{...addRegister("subtitle.en")}
														className="form-control"
														style={{ resize: "none", height: "120px" }}
													/>
													{addErrors?.subtitle?.en && (
														<p className="text-danger mt-1">
															{addErrors.subtitle.en.message}
														</p>
													)}
												</div>
											</div>
											<div className="modal-footer border-none">
												<button type="submit" className="btn btn-secondary">
													اضافة
												</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default LicensIndex;
